/* Timo's story copy, Spanish.
 *
 * This is a retelling, not a translation of story.en.js. Every line here is
 * spoken out loud by Timo, so write it the way it should sound, not the way
 * it should look.
 *
 * How it plays: the story is five chapters. Each chapter is ONE text to
 * speech call, composed as
 *     [celebration or encouragement for the last word] + [chapter] + [invitation]
 * so the whole story costs five calls. That matters: the TTS layer allows
 * five calls per sixty seconds before it locks out, and caps a single call
 * at 2500 characters and silently truncates past it. Keep every chapter
 * between 500 and 700 characters and the composed line stays safe.
 *
 * Two refrains repeat word for word on purpose. A child joins in by the
 * third time they hear them, and joining in is the whole point:
 *     Timo escucha. Timo espera. Timo ayuda.
 *     Dilo conmigo, dijo Timo.
 * Do not vary them for style. Sameness is the feature.
 *
 * The four target words are what the CHILD is asked to say. They are NOT
 * translations of the English targets. They were picked to be the easiest
 * words in their own chapter for a Spanish speaking child with a speech
 * delay: nido, mano, agua, luna. One or two syllables, early developing
 * sounds (n, d, m, plus open vowels), every word ending in a vowel. casa,
 * nuez and feliz were rejected for the s, the final z and the f plus final
 * z, and chapters 1, 2 and 4 were rewritten so the easier word appears
 * naturally several times. Do not swap one for a nicer word.
 */

const storyEs = {
  'story.title': 'El bosque verde de Timo',
  // Timo hands the telling over to Hoppy, then the recorded story plays.
  'story.handoff': "¡Oye! Le voy a pedir a mi amigo Hoppy que la cuente.",

  // ==== Capítulo 1: quién es Timo ====
  'story.ch1':
    'Timo vive en un bosque grande y verde. Timo es pequeño. Timo tiene una cola suave con rayas. ' +
    'Timo tiene unas orejas grandes y redondas. Las orejas grandes sirven para escuchar. ' +
    'En el bosque viven muchos animales. Hay un oso grande y lento. Hay un pájaro pequeño. ' +
    'Hay dos ardillas con mucha hambre. Todos hablan al mismo tiempo. Hay mucho ruido. ' +
    'Pero Timo no habla primero. Timo escucha. Timo espera. Timo ayuda. ' +
    'Timo tiene un nido en un árbol muy viejo. Su nido es blando y calentito. ' +
    'Desde su nido, Timo mira la luna. El nido de Timo es el mejor sitio del bosque.',

  // ==== Capítulo 2: las dos ardillas ====
  'story.ch2':
    'Un día las dos ardillas encontraron una nuez. Era una nuez grande y marrón. ' +
    'Las dos ardillas querían esa nuez. Una ardilla puso su mano en la nuez. ' +
    'La otra ardilla puso su mano en la nuez también. Tiraron para un lado. ' +
    'Tiraron para el otro lado. No dijeron ni una palabra. Solo tiraban y tiraban. ' +
    'Entonces Timo llegó y se sentó a su lado. Timo escucha. Timo espera. Timo ayuda. ' +
    'Timo dijo, dime qué quieres. Dilo conmigo, dijo Timo. ' +
    'La primera ardilla dijo, yo quiero la nuez. La segunda ardilla dijo, yo también quiero la nuez. ' +
    'Ahora ya lo sabemos, dijo Timo. La nuez es para las dos. ' +
    'Partieron la nuez en dos trozos iguales. Cada ardilla tiene media nuez en la mano.',

  // ==== Capítulo 3: el pájaro pequeño, el corazón de la historia ====
  'story.ch3':
    'Después llegó el pájaro pequeño. Se sentó en una rama baja. Tenía calor y tenía sed. ' +
    'El pájaro quería algo, pero la palabra no salía. Abrió el pico. No salió nada. ' +
    'Miró sus patitas. Nadie tenía prisa. Timo escucha. Timo espera. Timo ayuda. ' +
    'Timo se sentó a su lado un ratito largo y tranquilo. ' +
    'Entonces Timo dijo la palabra primero, despacio y bajito. Agua. Dilo conmigo, dijo Timo. ' +
    'El pájaro lo intentó. A. Lo intentó otra vez. Agua. ¡Lo dijo! ¡Dijo agua! ' +
    'Timo dio saltos de alegría. Todo el bosque verde aplaudió al pájaro pequeño.',

  // ==== Capítulo 4: el bosque cambia, Timo escucha a los niños ====
  'story.ch4':
    'Desde ese día el bosque cambió. Cuando el oso quería una mora, decía mora. ' +
    'Cuando las ardillas querían jugar, decían jugar. Cuando el pájaro tenía sed, decía agua. ' +
    'Nadie tiraba. Nadie empujaba. Ahora todos tenían su palabra. Timo estaba contento. ' +
    'Todo el bosque estaba contento. Una noche Timo se sentó en su piedra calentita y miró la luna. ' +
    'La luna era grande y redonda. La luna alumbraba todo el bosque. ' +
    'Y entonces Timo escuchó algo nuevo. Muy lejos, detrás de los árboles, había niños. ' +
    'Los niños tenían cosas grandes que contar. Cosas grandes, divertidas y bonitas. ' +
    'Pero las palabras se quedaban dentro. Timo se quedó muy quieto. Timo pensó en el pájaro pequeño.',

  // ==== Capítulo 5: Timo llega hasta el niño ====
  'story.ch5':
    'Por la mañana Timo preparó una bolsa pequeña. Se despidió del oso grande y lento. ' +
    'Se despidió de las dos ardillas. Se despidió del pájaro pequeño. ' +
    'El pájaro le cantó una canción, y la canción tenía muchas palabras dentro. ' +
    'Después Timo salió del bosque grande y verde. Caminó un camino muy largo. ' +
    'Llevó las orejas bien abiertas todo el rato. Timo escucha. Timo espera. Timo ayuda. ' +
    'Y un día, muy lejos del bosque, te escuchó a ti. Así que aquí estoy. ' +
    'Ya no estoy en el bosque. Estoy aquí contigo. ' +
    'Y tú tienes cosas grandes que contar. Me encantaría escucharlas.',

  // ==== Las cuatro invitaciones: lo que el niño dice en voz alta ====
  'story.invite1': 'El nido de Timo está en un árbol muy viejo. Di nido conmigo.',
  'story.invite2': 'Cada ardilla tiene media nuez en la mano. Di mano conmigo.',
  'story.invite3': 'El pájaro pequeño encontró su palabra. Di agua conmigo.',
  'story.invite4': 'Timo miró la luna grande y redonda. Di luna conmigo.',

  // ==== Las cuatro palabras objetivo ====
  'story.word1': 'nido',
  'story.word2': 'mano',
  'story.word3': 'agua',
  'story.word4': 'luna',

  // ==== Si el niño lo dice ====
  'story.celebrate1': '¡Nido! Lo dijiste, y mis orejas grandes se movieron de alegría.',
  'story.celebrate2': '¡Mano! ¡Qué bien lo hiciste! Las dos ardillas te saludan con la mano.',
  'story.celebrate3': '¡Agua! Lo dijiste igual que el pájaro. Estoy muy orgulloso de ti.',
  'story.celebrate4': '¡Luna! ¡Qué bonito! La luna brilla para ti también.',

  // ==== Si el niño no lo dice, la historia sigue igual de contenta ====
  'story.encourage1': 'Nido, nido, un nido blando en el bosque. Ven a conocer a mis amigos.',
  'story.encourage2': 'Mano, mano, media nuez en cada mano. Ahora ven a conocer al pájaro pequeño.',
  'story.encourage3': 'Agua, agua, un trago de agua fresca. Ven a ver qué pasó después.',
  'story.encourage4': 'Luna, luna, la luna alumbra todo el bosque. Ahora ven conmigo hasta el final.',

  'story.ending':
    'Vuelve mañana y te contaré la historia del oso y la última mora. Buenas noches, duerme bien.',
};

export default storyEs;
